var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('list-filter-selector',{attrs:{"selected":_vm.selected,"items":_vm.items,"column-id":_vm.columnId,"max-list-length":0},on:{"input":_vm.toggleSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }